import { Container } from "@material-ui/core";

import { Generator } from "../../../../components/Generator";
import { Grid } from "../../../../components/Grid";
import { Heading } from "../../../../components/Heading";
import { Sidebar } from "../../../../components/Navigation/Sidebar";
import { FormType } from "../../../../components/enums";
import {
  usePreventRefresh,
  useScrollDocument,
  useShouldRedirectToHomepage,
  useShowFooter,
  useTitle,
} from "../../../../hooks";
import { Url } from "../../../../router/enums";
import { selectIsFormValidated } from "../../../Welcome/welcome.selectors";

import styles from "./Perpetrator.module.scss";
import { form } from "./form";

export const Perpetrator = (): JSX.Element => {
  //JIRA LPPLWEBMOB-738
  //useShouldRedirectToHomepage(selectIsFormValidated);
  useShowFooter();
  useScrollDocument();
  useTitle("Ayvens OC");
  usePreventRefresh();

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Zgłoś szkodę z OC sprawcy
      </Heading>
      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar
          currentRoute={Url.OC_PROPERTY_PERPETRATOR}
          type={FormType.OC_PROPERTY}
        />
        <Generator
          form={form}
          render={(generatedForm) => (
            <Grid item xs={12} md={8}>
              {generatedForm}
            </Grid>
          )}
        />
      </Grid>
    </Container>
  );
};
